var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2 23H22.8C19.06 23 16 26.06 16 29.8V40H22.8V29.8H77.2V40H84V29.8C84 26.06 80.94 23 77.2 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2 70.5999H22.8V60.3999H16V70.5999C16 74.3399 19.06 77.3999 22.8 77.3999H77.2C80.94 77.3999 84 74.3399 84 70.5999V60.3999H77.2V70.5999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.826 35.0699C58.67 32.7579 54.896 32.7579 53.74 35.0699L43.2 56.1839L39.426 48.6699C38.848 47.5139 37.692 46.7999 36.4 46.7999H16V53.5999H34.292L40.14 65.3299C40.752 66.4859 41.908 67.1999 43.2 67.1999C44.492 67.1999 45.648 66.4859 46.226 65.3299L56.8 44.2159L60.574 51.7299C61.152 52.8859 62.308 53.5999 63.6 53.5999H84V46.7999H65.708L59.826 35.0699Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.1b32a0c5d36e15759bcaa6ae6b2ea694.svg";
export { ForwardRef as ReactComponent };